var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThreeDots(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 13.3337C6.06971 13.3337 6.66667 12.7367 6.66667 12.0003C6.66667 11.2639 6.06971 10.667 5.33333 10.667C4.59695 10.667 4 11.2639 4 12.0003C4 12.7367 4.59695 13.3337 5.33333 13.3337Z",
    fill: "#9293A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0003 13.3337C12.7367 13.3337 13.3337 12.7367 13.3337 12.0003C13.3337 11.2639 12.7367 10.667 12.0003 10.667C11.2639 10.667 10.667 11.2639 10.667 12.0003C10.667 12.7367 11.2639 13.3337 12.0003 13.3337Z",
    fill: "#9293A0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6663 13.3337C19.4027 13.3337 19.9997 12.7367 19.9997 12.0003C19.9997 11.2639 19.4027 10.667 18.6663 10.667C17.93 10.667 17.333 11.2639 17.333 12.0003C17.333 12.7367 17.93 13.3337 18.6663 13.3337Z",
    fill: "#9293A0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDots);
export default __webpack_public_path__ + "static/media/threeDots.5a366541c83e21abb7f1a97be6c20bbd.svg";
export { ForwardRef as ReactComponent };